import { render, staticRenderFns } from "./MobileVideoList.vue?vue&type=template&id=2360a774&scoped=true&"
import script from "./MobileVideoList.vue?vue&type=script&lang=js&"
export * from "./MobileVideoList.vue?vue&type=script&lang=js&"
import style0 from "./MobileVideoList.vue?vue&type=style&index=0&id=2360a774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360a774",
  null
  
)

export default component.exports